const sidenavSliderSections = document.querySelectorAll( "section.sidenav-slider" );
console.log( "sidenav is: ", sidenavSliderSections );
sidenavSliderSections.forEach( ( section ) => {
  const isDesktop = window.innerWidth >= 1024;

  const slider = tns( {
    container: section.querySelector( ".slider" ),
    items: 1,
    autoplay: isDesktop, // Enable autoplay only on desktop
    controls: true,
    nav: true,
    navContainer: section.querySelector( ".slider-nav" ),
    loop: true,
    autoplayButtonOutput: false,
    controlsContainer: section.querySelector( ".slider-controls" ),
    speed: 400,
    gutter: 16,
    fixedHeight: true,
    mode: "gallery",
  } );

  // Save instance for dropdown control
  section.sliderInstance = slider;

  // Get desktop menu <li> elements
  const desktopMenuItems = section.querySelectorAll( "#desktop-menu li" );

  // Listen for slide changes to update desktop menu
  slider.events.on( "indexChanged", () => {
    // Get current slide index (0-based)
    const info = slider.getInfo();
    const currentIndex = info.displayIndex - 1; // displayIndex is 1-based

    // Remove active class from all desktop menu items
    desktopMenuItems.forEach( ( li ) => li.classList.remove( "tns-nav-active" ) );

    // Add active class to the current one, if exists
    if ( desktopMenuItems[ currentIndex ] ) {
      desktopMenuItems[ currentIndex ].classList.add( "tns-nav-active" );
    }
  } );
} );